module.exports = __webpack_public_path__ + "img/horizontal_3_4_7005.c5e173d6.png";